import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-broadcastings-tv-format-card',
  templateUrl: './broadcastings-tv-format-card.component.html',
  styleUrls: ['./broadcastings-tv-format-card.component.scss']
})
export class BroadcastingsTvFormatCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('tvformatdevices-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('tvformatdevices-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.formatDevicesAvailables;
      this.disableCount = this.data.formatDevicesUnavailables;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('tvformatdevices-counts-spinner');
    }
  }
}
